import { useMemo } from 'react';
import { cn } from '../../utils/cn';
import type { CheckboxProps } from './checkbox.types';
import styles from './checkbox.module.css';

const SIZE_CLASSES = {
    small: styles.checkboxSmall,
    medium: styles.checkboxMedium,
    large: styles.checkboxLarge,
} as const;

export const useCheckboxStyles = ({
    className,
    size = 'medium',
    mode = 'normal',
    disabled = false,
}: Pick<CheckboxProps, 'className' | 'size' | 'mode' | 'disabled'>) => {
    const containerClassName = useMemo(() => cn(styles.container, className), [className]);

    const wrapperClassName = useMemo(
        () => cn(styles.checkboxWrapper, SIZE_CLASSES[size], mode === 'reverse' && styles.checkboxReverse),
        [size, mode]
    );

    const inputClassName = useMemo(
        () => cn(styles.checkbox, SIZE_CLASSES[size], mode === 'reverse' && styles.checkboxReverse),
        [size, mode]
    );

    const labelClassName = useMemo(
        () => cn(styles.label, disabled ? styles.labelDisabled : styles.labelEnabled),
        [disabled]
    );

    return {
        containerClassName,
        wrapperClassName,
        inputClassName,
        labelClassName,
    };
};
